import { render } from "./MainScreen.vue?vue&type=template&id=888662ce"
import script from "./MainScreen.vue?vue&type=script&lang=js"
export * from "./MainScreen.vue?vue&type=script&lang=js"

import exportComponent from "/home/ruslan/projects/sporttiming/app/front/do/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__